import ReactGTMModule from 'react-gtm-module';

/**
 * `initialize` só pode correr **uma vez** por carregamento de página.
 *
 * O `react-gtm-module` faz `JSON.stringify` do `dataLayer` que recebe. Como o
 * `window.dataLayer` vai sendo preenchido pelo próprio GTM e por outros scripts
 * — com entradas que referenciam nós do DOM, e portanto fibers do React — a
 * segunda chamada rebentava com «Converting circular structure to JSON»,
 * derrubando o render da app inteira.
 */
let initialized = false;

class TagManager {
  constructor() {
    //@ts-ignore
    this.reactGTMModule = ReactGTMModule;
  }

  initialize(gtmId: string): void {
    if (initialized) return;
    initialized = true;

    //@ts-ignore
    window.dataLayer = window.dataLayer || [];
    // Só o `gtmId`: passar de volta o `window.dataLayer` vivo é o que tornava a
    // serialização circular.
    //@ts-ignore
    this.reactGTMModule.initialize({ gtmId });
  }

  dataLayer(params: Record<string, any>): void {
    //@ts-ignore
    this.reactGTMModule.dataLayer({
      dataLayer: params
    });
  }
}

/** Apenas para testes: repõe o estado de inicialização entre casos. */
export function resetTagManagerForTests(): void {
  initialized = false;
}

export default TagManager;
